import { AdminListView } from "./AdminListView";
import { capabilityAdapter } from "./capabilityAdapter";

export function CapabilityAdminPage() {
  return <AdminListView adapter={capabilityAdapter} />;
}
